import { render, staticRenderFns } from "./PisCofinsTab.vue?vue&type=template&id=6ac58a7a&"
import script from "./PisCofinsTab.vue?vue&type=script&lang=js&"
export * from "./PisCofinsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports